import { Stack, styled, Typography } from '@mui/material';

interface ItemProps {
  alert?: boolean;
}

export const Item = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'alert',
})<ItemProps>(({ theme, alert }) => ({
  padding: theme.spacing(1),
  gap: theme.spacing(2),
  ...(alert && {
    border: `1px solid ${theme.palette.warning.main}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.warning.light,
  }),
}));
Item.defaultProps = {
  direction: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  useFlexGap: true,
};

export const Result = styled(Typography)({
  flexShrink: 0,
  flexBasis: '20%',
});

export const Column = styled(Stack)({
  hr: {
    width: '100%',
  },
});
Column.defaultProps = {
  spacing: 2,
  useFlexGap: true,
};

export const List = styled('ul')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),

  li: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: theme.spacing(1.5),
    marginLeft: theme.spacing(2),
  },
}));
